module.exports = "/static/assets/dfffae66f4a57806d99b490b385319bc.gif";